const app = {
  sidebarMountEl: 'sidebarMountApp',
  appMountEl: '#categoryMountApp',
  searchFilterMountEl: '#searchFilterMountApp',
  allCategoriesMountEl: '#allCategoriesMountApp',
  facetsMountEl: '#facetsMountApp',
  sortedProductListMountEl: '#sortedProductListMountApp'
}

const data = {
  rootCategory: '#jsonRootCategory',
  parentCategory: '#jsonParentCategory',
  childCategories: '#jsonChildPublishedCategory',
  siblingCategories: '#jsonSiblingPublishedCategory',
  productCategories: '#jsonProductCategories',
  shortestShippingDates: '#jsonShortestShippingDates',
  maxQuantityPrice : '#maxQuantityPrice'
}

export { app, data }
